export enum ContentBlockTypes {
  Markdown = 'markdown',
  Images = 'images',
  Ticker = 'ticker',
}
